(function () {
  'use strict';
  document.querySelectorAll('[data-gallery-lightbox]').forEach(function (dialog) {
    if (dialog.dataset.initialized || !dialog.showModal) return;
    var gallery = document.getElementById(dialog.dataset.galleryLightbox);
    var stage = gallery && gallery.querySelector('[data-main-photo]');
    var mainImage = gallery && gallery.querySelector('[data-main-photo-img]');
    if (!stage || !mainImage) return;
    dialog.dataset.initialized = 'true';
    var open = document.createElement('button');
    open.type = 'button';
    open.className = 'product-gallery__open';
    open.setAttribute('aria-label', dialog.dataset.openLabel);
    open.setAttribute('aria-haspopup', 'dialog');
    open.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5M3 3l6 6m12-6-6 6M3 21l6-6m12 6-6-6"/></svg>';
    stage.appendChild(open);
    var viewport = dialog.querySelector('[data-lightbox-viewport]');
    var image = dialog.querySelector('[data-lightbox-image]');
    var thumbs = dialog.querySelector('[data-lightbox-thumbs]');
    var request = 0, outgoing = null, qualityRequest = null;
    var cache = new Map();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var previous = dialog.querySelector('[data-lightbox-prev]');
    var next = dialog.querySelector('[data-lightbox-next]');
    var items = [], index = 0, scale = 1, x = 0, y = 0;
    var pointers = new Map(), gesture = null, lastTap = 0, overflow = '', scrollY = 0;
    function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
    function render() {
      var width = viewport.clientWidth, height = viewport.clientHeight;
      var fit = Math.min(width / (image.naturalWidth || width), height / (image.naturalHeight || height));
      var maxX = Math.max(0, ((image.naturalWidth || width) * fit * scale - width) / 2);
      var maxY = Math.max(0, ((image.naturalHeight || height) * fit * scale - height) / 2);
      x = clamp(x, -maxX, maxX); y = clamp(y, -maxY, maxY);
      image.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
      viewport.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
      if (scale > 1.01 && items[index]) improve(items[index], true, request);
    }
    function reset() { scale = 1; x = 0; y = 0; render(); }
    function show(at, immediate) {
      var target = clamp(at, 0, items.length - 1);
      if (!immediate && target === index) return;
      index = target;
      var ticket = ++request;
      thumbs.querySelectorAll('button').forEach(function (button, i) {
        button.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var active = thumbs.children[index];
      if (active) thumbs.scrollTo({ left: active.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - active.clientWidth) / 2, behavior: immediate || reducedMotion.matches ? 'instant' : 'smooth' });
      previous.disabled = index === 0; next.disabled = index === items.length - 1;
      qualityRequest = null;
      if (outgoing) outgoing.remove();
      if (!immediate && !reducedMotion.matches && image.complete && image.naturalWidth) {
        outgoing = image.cloneNode();
        outgoing.removeAttribute('data-lightbox-image');
        outgoing.alt = ''; outgoing.setAttribute('aria-hidden', 'true');
        outgoing.classList.add('product-lightbox__outgoing');
        viewport.appendChild(outgoing);
        var ghost = outgoing;
        var fade = ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-out', fill: 'forwards' });
        fade.onfinish = function () { ghost.remove(); if (outgoing === ghost) outgoing = null; };
      }
      var item = items[target], ready = cache.get(item.screen);
      image.src = ready && ready.image.complete && ready.image.naturalWidth ? item.screen : item.preview;
      image.alt = item.alt;
      reset(); lastTap = 0;
      improve(item, false, ticket);
      [target - 1, target + 1].forEach(function (i) { if (items[i]) load(items[i].screen); });
    }
    function load(src) {
      if (!cache.has(src)) {
        var picture = new Image();
        var loaded = new Promise(function (resolve) {
          picture.onload = function () { resolve(true); };
          picture.onerror = function () { resolve(false); };
        });
        cache.set(src, { image: picture, loaded: loaded });
        picture.src = src;
      }
      return cache.get(src).loaded;
    }
    function improve(item, detail, ticket) {
      var src = detail ? item.src : item.screen;
      if (detail && qualityRequest === src) return;
      if (detail) qualityRequest = src;
      load(src).then(function (ok) {
        if (!ok || ticket !== request || !dialog.open || (!detail && scale > 1.01)) return;
        if (image.src !== new URL(src, location.href).href) image.src = src;
      });
    }
    function buildThumbs() {
      thumbs.replaceChildren();
      items.forEach(function (item, i) {
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'product-lightbox__thumb';
        button.setAttribute('aria-label', (item.alt || dialog.getAttribute('aria-label')) + ' — ' + (i + 1));
        var preview = document.createElement('img');
        preview.src = item.preview; preview.alt = ''; preview.width = 80; preview.height = 100;
        button.appendChild(preview);
        button.addEventListener('click', function () { show(i); });
        thumbs.appendChild(button);
      });
    }
    function identity(src) { try { return new URL(src, location.href).pathname; } catch (e) { return src; } }
    function large(src) { var url = new URL(src, location.href); url.searchParams.set('width', '2400'); return url.href; }
    open.addEventListener('click', function () {
      if (mainImage.hidden) return;
      items = Array.from(gallery.querySelectorAll('[data-gallery-thumb]')).filter(function (thumb) {
        return thumb.dataset.mediaType === 'image';
      }).map(function (thumb) { return { src: large(thumb.dataset.fullSrc), screen: thumb.dataset.fullSrc, preview: thumb.dataset.previewSrc, alt: thumb.dataset.fullAlt || '', thumb: thumb }; });
      var at = items.findIndex(function (item) { return identity(item.src) === identity(mainImage.src); });
      if (at < 0) { items.unshift({ src: large(mainImage.src), screen: mainImage.src, preview: mainImage.src, alt: mainImage.alt }); at = 0; }
      overflow = document.documentElement.style.overflow; scrollY = window.scrollY;
      buildThumbs();
      dialog.showModal(); document.documentElement.style.overflow = 'hidden'; show(at, true);
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      ++request;
      if (outgoing) { outgoing.remove(); outgoing = null; }
      var viewed = items.find(function (item) { return identity(item.src) === identity(image.src); });
      if (viewed && viewed.thumb) viewed.thumb.click();
      document.documentElement.style.overflow = overflow;
      pointers.clear(); gesture = null;
      open.focus({ preventScroll: true }); window.scrollTo(0, scrollY);
    });
    previous.addEventListener('click', function () { show(index - 1); });
    next.addEventListener('click', function () { show(index + 1); });
    function toggleZoom() { scale = scale > 1.01 ? 1 : 2.5; x = 0; y = 0; render(); }
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    function begin() {
      var points = Array.from(pointers.values());
      if (points.length === 2) {
        gesture = { pinch: true, distance: Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y), scale: scale, x: x, y: y, cx: (points[0].x + points[1].x) / 2, cy: (points[0].y + points[1].y) / 2 };
      } else if (points.length === 1) {
        gesture = { startX: points[0].x, startY: points[0].y, x: x, y: y, scale: scale, moved: false, afterPinch: true };
      }
    }
    viewport.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      viewport.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      begin();
      if (pointers.size === 1) gesture.afterPinch = false;
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId) || !gesture) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      var points = Array.from(pointers.values());
      if (gesture.pinch && points.length >= 2) {
        var distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
        scale = clamp(gesture.scale * distance / Math.max(1, gesture.distance), 1, 4);
        var box = viewport.getBoundingClientRect(), ratio = scale / gesture.scale;
        x = gesture.x * ratio + (gesture.cx - box.left - box.width / 2) * (1 - ratio) + (points[0].x + points[1].x) / 2 - gesture.cx;
        y = gesture.y * ratio + (gesture.cy - box.top - box.height / 2) * (1 - ratio) + (points[0].y + points[1].y) / 2 - gesture.cy;
        render();
      } else if (!gesture.pinch && points.length === 1) {
        var dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
        if (Math.hypot(dx, dy) > 8) gesture.moved = true;
        if (scale > 1.01) { x = gesture.x + dx; y = gesture.y + dy; render(); }
      }
    });
    function end(event) {
      if (!pointers.has(event.pointerId)) return;
      if (event.type === 'pointerup' && pointers.size === 1 && gesture && !gesture.pinch && !gesture.afterPinch) {
        var dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
        if (gesture.scale <= 1.01 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1));
        else if (!gesture.moved) {
          var now = Date.now();
          if (now - lastTap < 300) { toggleZoom(); lastTap = 0; } else lastTap = now;
        }
      }
      pointers.delete(event.pointerId);
      if (pointers.size) begin(); else gesture = null;
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    image.addEventListener('load', render);
    window.addEventListener('resize', function () { if (dialog.open) render(); });
  });
})();
